module.exports = __webpack_public_path__ + "static/media/cylindrical-roller-bearing.9ea84479.jpg";